import * as Yup from "yup";

export const productFormValidation = Yup.object().shape({
  ProductName: Yup.string().required("Name is required!").nullable(),
  BoardId: Yup.string().required("Board is required!").nullable(),
  ClassId: Yup.string().required("Class is required!").nullable(),
  SubjectId: Yup.array().required("Subject is required!").nullable(),
  Price: Yup.number()
    .required("Product cost is required!")
    .nullable().moreThan(-1, "Product cost must be greater than or equal to 0!")
    // .test(
    //   "Is positive?",
    //   "ERROR: The number must be greater than or equal to 0!",
    //   (value: any) => value >= 0
    // ),
});
